import { setEmail, setEmailCheck } from '../../utils/variables';

export function removeEmail() {
  setEmail('');
  setEmailCheck(false);
  const email = document.querySelector('#email');
  if (email) {
    email.value = '';
    document
      .querySelector('.emailContinue__btn')
      .classList.add('disabled');
  }
}
